import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"filter\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"nonzero\" d=\"M27 6.6a1 1 0 00-1-.6H6a1 1 0 00-1 .6c0 .3 0 .8.2 1l7.8 9.2V23c0 .4.2.7.6.9l4 2 .4.1a1 1 0 001-1v-8.2l7.8-9.2c.2-.2.3-.7.1-1zm-9.8 9.2a1 1 0 00-.2.7v6.9l-2-1v-6c0-.2 0-.4-.2-.6L8.2 8h15.6l-6.6 7.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol